<!--
 * @Author:
 * @Description: 对象属性完整性报表
-->
<template>
  <el-card class="h-full" :body-style="{ height: '100%' }">
    <el-row class="mb-10px" type="flex" align="middle">
      <selectStandardId @updateStandardId="updateStandardId" />
      <el-select
        v-model="searchData.classId"
        placeholder="位号类别"
        class="!w-300px !h-36px ml-10px"
        size="small"
        :filter-method="getParentTypeList"
        popper-class="tag_select-popper"
        ref="tagSearchSelect"
        clearable
        filterable
      >
        <el-option :label="tagSearchName" :value="searchTagClassIds">
          <el-tree
            :data="tagTreeData"
            :props="classTreeProps"
            node-key="id"
            @node-click="handleSearchTagTreeClick"
            :expand-on-click-node="false"
          >
            <div
              slot-scope="{ node, data }"
              class="text-14px h-full tree-node font-normal"
              style="line-height: 24px; width: calc(100% - 40px)"
            >
              <span :class="{ 'text-blue': searchTagClassIds === data.id }">
                {{ data.code }}({{ node.label }})
              </span>
              <i v-if="searchTagClassIds === data.id" class="el-icon-check text-blue font-bold"></i>
            </div>
          </el-tree>
        </el-option>
      </el-select>
      <el-input
        class="w-200px mx-10px"
        size="small"
        v-model="searchData.keyword"
        placeholder="位号编码或名称"
        clearable
      ></el-input>
      <span class="text-14px leading-36px mr-10px">属性完整度(必填)</span>
      <el-input
        class="w-100px mr-10px"
        size="small"
        v-model="searchData.start"
        placeholder="最小"
        clearable
      ></el-input>
      <el-input
        class="w-100px mr-10px"
        size="small"
        v-model="searchData.end"
        placeholder="最大"
        clearable
      ></el-input>
      <el-button size="small" type="primary" @click="searchList">搜索</el-button>
      <el-button
        size="small"
        type="primary"
        :disabled="!$hasAccess('export')"
        :loading="exportLoading"
        @click="exportData"
        >导出</el-button
      >
    </el-row>
    <el-table
      :data="tableData"
      v-loading="tableLoading"
      class="mt-20px"
      height="calc(100% - 104px)"
      border
      stripe
    >
      <el-table-column type="index" width="50" :label="`${$t('serialNumber')}`">
        <template slot-scope="scope">
          <div>
            {{ scope.$index + 1 + (page.pageNo - 1) * page.pageSize }}
          </div>
        </template>
      </el-table-column>
      <el-table-column
        v-for="(val, index) in tableHeaders"
        :key="index"
        :label="val.name"
        :prop="val.columnName"
        show-overflow-tooltip
      ></el-table-column>
    </el-table>
    <el-pagination
      class="mt-20px text-right"
      background
      layout="total, sizes, prev, pager, next, jumper"
      :total="page.total"
      :current-page.sync="page.pageNo"
      :page-size.sync="page.pageSize"
      :page-sizes="$pageSizeAll"
      @current-change="getTableData"
      @size-change="searchList"
    >
    </el-pagination>
  </el-card>
</template>

<script>
import dataValidationReportService from '@/services/dataValidationReportService'
import stdClassListService from '@/services/stdClassListService'
import fnMixin from '@/assets/js/fnMixins'
import selectStandardId from '../../components/selectStandardId'

export default {
  name: 'objectAttributeReport',
  components: {
    selectStandardId,
  },
  mixins: [fnMixin],
  data() {
    return {
      standardId: localStorage.getItem('standardId'),
      searchData: {
        classId: '',
        keyword: '',
        start: '',
        end: '',
      },
      tagList: [],
      tableData: [],
      page: {
        pageNo: 1,
        pageSize: 15,
        total: 0,
      },
      tableLoading: false,
      exportLoading: false,
      tableHeaders: [],
      tagTreeData: [],
      classTreeProps: { label: 'name', children: 'children' },
      searchTagClassIds: '',
      tagSearchName: '',
    }
  },
  created() {
    this.searchList()
    this.getParentTypeList()
  },
  methods: {
    updateStandardId(val) {
      this.standardId = val
      this.searchList()
      this.getParentTypeList()
    },
    // 搜索列表
    searchList() {
      this.page.pageNo = 1
      this.getTableData()
    },
    // 获取表格数据
    async getTableData() {
      const params = {
        standardId: this.standardId,
        skipCount: (this.page.pageNo - 1) * this.page.pageSize,
        maxResultCount: this.page.pageSize,
        ...this.searchData,
      }
      this.tableLoading = true
      const res = await dataValidationReportService.getTagAttributeIntegrityList(params)
      this.tableLoading = false
      if (res && res.code === 0) {
        this.tableHeaders = res.headers.filter((item) => {
          return item.isDisplay
        })
        this.tableData = res.data
        this.page.total = res.totalCount
      }
    },
    // 获取对象类别列表
    async getParentTypeList(val) {
      const parameter = {
        standard_id: this.standardId,
        data_type: 1,
        approve_status: 1, // 已发布的实体
        info_type: 0, // 对象
        keyword: val,
        catecode: 'Tag',
      }
      const res = await stdClassListService.getClassList(parameter)
      if (res && res.code === 0 && res.data) {
        this.tagTreeData = res.data.length > 0 ? this.listToTree(res.data) : []
      }
    },
    // 列表转树
    listToTree(list) {
      // 先找出所有有效的父节点ID
      const parentIds = new Set(
        list.map((item) => {
          return item.id
        })
      )

      const result = list.reduce((prev, curr) => {
        curr.pathName = `/${curr.name}/`
        curr.children = list.filter((v) => {
          return v.parentId === curr.id
        })

        // 如果是根节点或找不到父节点,就放到第一级
        if (
          curr.parentId === '00000000-0000-0000-0000-000000000000' ||
          curr.parentId === '' ||
          curr.parentId === null ||
          !parentIds.has(curr.parentId)
        ) {
          prev.push(curr)
        }
        return prev
      }, [])

      return result
    },
    handleSearchTagTreeClick(node) {
      this.searchTagClassIds = node.id
      this.tagSearchName = node.name
      this.searchData.classId = node.id
      this.$refs.tagSearchSelect.blur()
    },
    // 导出
    async exportData() {
      const params = {
        standardId: this.standardId,
        skipCount: (this.page.pageNo - 1) * this.page.pageSize,
        maxResultCount: this.page.pageSize,
        ...this.searchData,
      }
      this.exportLoading = true
      const res = await dataValidationReportService.getTagAttributeIntegrityExport(params)
      this.exportLoading = false
      if (res) {
        this.downLoadBlob({
          name: '对象属性完整性报表导出结果.xlsx',
          data: res,
        })
      }
    },
  },
}
</script>

<style lang="scss" scoped>

.el-popper.tag_select-popper .el-select-dropdown__item {
  height: 100% !important;
  padding: 0;
  font-weight: normal;
}
.tree-node {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.text-blue {
  color: #409eff;
}

</style>
